<template>
  <div class="menu-general">
    <div class="main-menu" :class="shortViewClass">
      <div>
    <div v-if="shortViewClass===''" class="admin-name" @click="titleClick">{{ $t('navigation.menuLinks.admin') }}</div>
        <menu-item
          v-for="item in menuItemsArray"
          :key="item.name"
          :item="item"
        ></menu-item>
      </div>
      <div class="test-ham" :class="hamClass" @click="hamMenuClick"></div>
    </div>
  </div>
</template>


<script>
import i18n from "@/locales";
import MenuItem from "./MenuItem";
import { mapGetters } from "vuex";
export default {
  components: {
    MenuItem,
  },
  data() {
    return {
      hamClass: "el-icon-d-arrow-left",
      menuItemsArray: [
        {
          icon: "el-icon-document-add",
          name: i18n.t("navigation.menuLinks.runTask.general"),
          menuSublist: [
            i18n.t("navigation.menuLinks.runTask.singleTask"),
            i18n.t("navigation.menuLinks.runTask.multiTask"),
          ],
          routerLinks: ["runTaskLink", "multiTaskLink"],
        },
        {
          icon: "el-icon-document-checked",
          name: i18n.t("navigation.menuLinks.statusTask.general"),
          menuSublist: [
            i18n.t("navigation.menuLinks.statusTask.running"),
            i18n.t("navigation.menuLinks.statusTask.finished"),
            i18n.t("navigation.menuLinks.statusTask.deleted"),
          ],
          routerLinks: [
            "statusRunLink",
            "statusFinishLink",
            "statusDeleteLink",
          ],
        },
        {
          icon: "el-icon-document",
          name: i18n.t("navigation.menuLinks.commonTask.general"),
          menuSublist: [
            i18n.t("navigation.menuLinks.commonTask.processes"),
            i18n.t("navigation.menuLinks.commonTask.services"),
            i18n.t("navigation.menuLinks.commonTask.logs"),
          ],
          routerLinks: ["processesLink", "servicesLink", "logsLink"],
        },
        {
          icon: "el-icon-collection",
          name: i18n.t("navigation.menuLinks.reference.general"),
          menuSublist: [
            i18n.t("navigation.menuLinks.reference.databases"),
            i18n.t("navigation.menuLinks.reference.apps"),
            i18n.t("navigation.menuLinks.reference.servers"),
            i18n.t("navigation.menuLinks.reference.users"),
            i18n.t("navigation.menuLinks.reference.roles"),
            i18n.t("navigation.menuLinks.reference.appParams"),
            i18n.t("navigation.menuLinks.reference.upgrades"),
          ],
          routerLinks: [
            "referenceBasesLink",
            "referenceSectionsLink",
            "referenceServersLink",
            "referenceUsersLink",
            "referenceRolesLink",
            "referenceAppParamsLink",
            'referenceUpgradesLink'
          ],
        },
        {
          icon: "el-icon-connection",
          name: i18n.t("navigation.menuLinks.config.general"),
          menuSublist: [
            i18n.t("navigation.menuLinks.config.configTree"),
            i18n.t("navigation.menuLinks.config.visuals"),
            i18n.t("navigation.menuLinks.config.configTasks"),
            i18n.t("navigation.menuLinks.config.roleSections"),
            i18n.t("navigation.menuLinks.config.sectionTasks"),
            i18n.t("navigation.menuLinks.config.roleTasks"),
          ],
          routerLinks: [
            "configTreeLink",
            "visualsLink",
            "configTasksLink",
            "roleSectionsLink",
            "sectionTasksLink",
            "roleTasksLink"
          ],
        },
        {
          icon: "el-icon-data-analysis",
          name: i18n.t("navigation.menuLinks.cron.general"),
          menuSublist: [
            i18n.t("navigation.menuLinks.cron.scheduler"),
            i18n.t("navigation.menuLinks.cron.history"),
          ],
          routerLinks: ["schedulerLink", "schedulerHistoryLink"],
        },
      ],
      shortViewClass: "",
    };
  },
  created() {
    // //console.log('in created', this.currentUserDenial);
    // //console.log(this.menuItemsArray);
    this.updateMenu();
    let menu = this.$localStorage.get("wa-menu");
    if (menu === "small") {
      this.hamClass = "el-icon-d-arrow-right";
      this.shortViewClass = "collapsed-menu";
    } else {
      this.hamClass = "el-icon-d-arrow-left";
      this.shortViewClass = "";
    }
  },
  methods: {
    hamMenuClick() {
      if (this.hamClass === "el-icon-d-arrow-left") {
        this.$store.commit("setMenu", "small");
        this.hamClass = "el-icon-d-arrow-right";
        this.shortViewClass = "collapsed-menu";
      } else {
        this.hamClass = "el-icon-d-arrow-left";
        this.$store.commit("setMenu", "full");
        this.shortViewClass = "";
      }
    },
    titleClick(){
      this.$router.push({name: "homeLink"});
    },
    updateMenu(){
      if(!this.currentUserDenial) return;
      for (let item = 0; item < this.menuItemsArray.length; item++) {
        for (
          let link = 0;
          link < this.menuItemsArray[item].routerLinks.length;
          link++
        ) {
          if (
            this.currentUserDenial.includes(
              this.menuItemsArray[item].routerLinks[link]
            )
          ) {
            // //console.log(this.menuItemsArray[item].routerLinks[link]);
            this.menuItemsArray[item].routerLinks.splice(link, 1);
            this.menuItemsArray[item].menuSublist.splice(link, 1);
            link--;
          }
        }
        if (this.menuItemsArray[item].routerLinks.length === 0) {
          this.menuItemsArray.splice(item, 1);
          item--;
        }
      }
    }
  },
  watch: {
    currentUserDenial() {
      this.updateMenu();
    },
  },
  computed: {
    ...mapGetters(["currentUserDenial", "theme"]),
  },
};
</script>

<style scoped>
.menu-general {
  z-index: 998;
}
.main-menu {
  width: var(--nav-left-width);
  background: var(--off-background);
  height: calc(100vh - var(--header-height));
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: auto;
  padding-top: var(--header-height);
  scrollbar-color: var(--off-background-selected) var(--off-background);
  scrollbar-width: thin;
}
.main-menu.collapsed-menu {
  width: var(--nav-left-small);
}

.main-menu::-webkit-scrollbar {
  width: 4px;
}

.main-menu::-webkit-scrollbar-track {
  /* background-color: rgb(198, 229, 240); */
  background-color: var(--off-background);
}

.main-menu::-webkit-scrollbar-thumb {
  /* background-color: rgb(162, 207, 223); */
  background-color: var(--off-background-selected);
}

.test-ham {
  color: var(--menu-text-color);
  background-color: var(--off-background-selected);
  padding: 10px 0px;
  text-align: center;
  cursor: pointer;
}
.test-ham:hover {
  background-color: var(--active-color);
  color: var(--menu-text-color-hover);
}
.admin-name{
  color: var(--menu-text-color-hover);
  cursor: pointer;
  position: absolute;
  top: calc(var(--header-height) / 4);
  left: 20px;
  font-weight: 500;
  font-size: 1.2em;
}
.admin-name:hover{
  color: white;
}
</style>